import types from './types';

const INITIAL_STATE = {
  isFetchingImpatientMetrics: false,

  result: [],
};

const metricsReducer = (state = INITIAL_STATE, action: any) => {
  switch (action.type) {

  case types.GET_INPATIENT_METRICS_REQUEST:
    return {
      ...state,
      result: [],
      isFetchingImpatientMetrics: true,
    };

  case types.GET_INPATIENT_METRICS_SUCCESS:
    return {
      ...state,
      result: action.payload,
      isFetchingImpatientMetrics: false,
    };

  case types.GET_INPATIENT_METRICS_FAILURE:
    return {
      ...state,
      result: [],
      isFetchingImpatientMetrics: false,
    };

  default:
    return state;
  }
};

export default metricsReducer;
